import { Injectable } from '@angular/core';
import { ApiHttpClient, ListOption, ListOptionRequest } from '../modules/tcm-core.module';
import { RegionOptionWithDescription } from '../models/users';

@Injectable({
  providedIn: 'root'
})
export class RegionDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public getRegionOptionsAsync(query: string, timeout?: Promise<any>): Promise<ListOption<number>[]> {
    const request: ListOptionRequest = { searchString: query };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('regions/options', request, timeout);
  }

  public getRegionOptionsWithDescriptionAsync(query: string, cancellationToken: Promise<any>): Promise<RegionOptionWithDescription[]> {
    const request: ListOptionRequest = { searchString: query };
    return this.httpClient.getJsonAsync<RegionOptionWithDescription[]>('regions/optionsWithDescription', request, cancellationToken);
  }

  public getAllRegionOptionsWithDescriptionAsync(cancellationToken: Promise<any>): Promise<RegionOptionWithDescription[]> {
    return this.httpClient.getJsonAsync<RegionOptionWithDescription[]>('regions/AllOptionsWithDescription', {}, cancellationToken);
  }
}
